// extracted by mini-css-extract-plugin
export default {"sidebar":"use-sidebar_sidebar__KNkrW","main":"use-sidebar_main__S+N1j","alwaysVisible":"use-sidebar_alwaysVisible__i5SKQ"};